import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { servicedeskLiveChatMyChatsRoute } from '@atlassian/jira-router-routes-servicedesk-live-chat-routes/src/servicedeskLiveChatMyChatsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { liveChatMyChatsEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-live-chat-my-chats/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const liveChatMyChatsPageEntryPoint = createPageEntryPoint({
	main: liveChatMyChatsEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const servicedeskLiveChatMyChatsRouteEntry = createEntry(
	servicedeskLiveChatMyChatsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-live-chat-my-chats-load',

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			getConsolidationStateResource(),
		],

		entryPoint() {
			return fg('live-chat-rovo-for-service') ? liveChatMyChatsPageEntryPoint : undefined;
		},

		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-live-chat-entries/src/servicedeskLiveChatMyChatsRouteEntry.tsx',
				whichExportToUse: 'servicedeskLiveChatMyChatsRouteEntry',
			},

			enabled: true,
		},
	}),
);
